import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    background-color: ${theme.v2.colors.neutral.highPure};;
    padding: 24px;
    margin: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-height: 100%;
      margin: 12px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0px;
      margin-top: 12px;
    }
  `}
`;

export const WrapperIconInfo = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    width: 100%;
    height: 100%;
    max-width: 1300px;
    gap: 32px;

    @media (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const Details = styled.aside`
  ${() => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
     max-width: 615px;
     gap: 24px;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: 500;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const HelperText = styled.span`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0%;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const HelperTextHighlight = styled.strong`
  ${({ theme }) => css`
    margin-left: 5px;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0%;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const Hint = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    gap: 8px;
    padding: 16px;
  `}
`;

export const HintContent = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
   gap: 12px;
`;

export const HintContentDescription = styled.span`
   ${({ theme }) => css`
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const HintContentDescriptionHighlight = styled.strong`
     ${({ theme }) => css`
      margin: 0 5px;
      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      color: ${theme.v2.colors.neutral.lowDark};
  `}
`;


export const Form = styled.form`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 84%;
    max-width: 500px;
    align-self: flex-end;
    gap: 26px;
    margin-top: 25px;

    @media (max-width: ${theme.breakpoints.md}) {
      align-self: auto;
    }
  `}
`;

export const FieldWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const Label = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 16px;
`;

export const WrapperButton = styled.div` 
  ${() => css`
    width: 100%;
    display: flex;
    gap: 16px;
    justify-content: flex-end;
  `}
`;


export const Loading = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 22px;
    height: 100%;
    width: 100%;
    height: 70vh;

    @media (max-width: ${theme.breakpoints.md}) {  
      gap: 0px;
    }
  `}
`;


export const WaitingText = styled.h3`
  ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-weight: 500;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;

    @media (max-width: ${theme.breakpoints.md}) {  
      font-size: 16px;
      font-style: normal;
      line-height: 150%;
    }
  `}
`;

export const WrapperDescriptionItems = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
`;

export const FormSubmitCompletedLayoutTitle = styled.h3`
  ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-weight: 500;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      
    @media (max-width: ${theme.breakpoints.md}) {  
       font-size: 24px;
       line-height: 130%;
       letter-spacing: 0%;
       text-align: center;
    }
  `}
`;

export const FormSubmitCompletedLayoutSubTitle = styled.span`
  ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-weight: 400;
      font-size: 18px;
      line-height: 150%;
      letter-spacing: 0%;
      text-align: center;
      
    @media (max-width: ${theme.breakpoints.md}) {  
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0%;
        text-align: center;
    }
  `}
`;

export const FormSubmitCompletedLayout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    width: 100%;;
`;

export const WrapperCheckedImage = styled.img``;
